import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement); 
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

registerServiceWorker();
